export default {
  // --- New keys (Figma rebuild) ---

  /** RevDrawer title prop — shown in the drawer chrome header. */
  header: {
    id: 'front_office_product_core_telco_drawer_header',
    defaultMessage: 'Explore plans',
  },

  /** Intro content heading inside the drawer body. */
  title: {
    id: 'front_office_product_core_telco_drawer_title',
    defaultMessage:
      'Save up to 80% on your mobile plan with an exclusive offer',
  },

  /** Intro content paragraph inside the drawer body. */
  body: {
    id: 'front_office_product_core_telco_drawer_body',
    defaultMessage:
      "Pick a flexible mobile plan and we'll send a promo code to your inbox so you can redeem it directly on our partner's site.",
  },

  /** Footer info card — "want to keep your number?" heading. */
  keepNumberTitle: {
    id: 'front_office_product_core_telco_drawer_keep_number_title',
    defaultMessage: 'Want to keep your number?',
  },

  /** Footer info card — transfer info paragraph. */
  keepNumberBody: {
    id: 'front_office_product_core_telco_drawer_keep_number_body',
    defaultMessage:
      "It's an easy transfer when you activate your new plan and usually takes just a few minutes.",
  },

  // --- Legacy keys (preserved for backward-compat; removable once USB2CS-903 reaches 100% rollout and translation strings are decommissioned) ---

  /** @deprecated Use `header` for the RevDrawer title prop. */
  closeButtonLabel: {
    id: 'product_page_telco_comparison_drawer_close_button_label',
    defaultMessage: 'Close plan comparison',
  },

  /** @deprecated Was the old RevDrawer title. Now replaced by `header`. */
  comparisonTableLabel: {
    id: 'product_page_telco_comparison_drawer_comparison_table_label',
    defaultMessage: 'Plan comparison table',
  },

  networkLabel: {
    id: 'product_page_telco_comparison_drawer_network_label',
    defaultMessage: 'Network',
  },

  dataLabel: {
    id: 'product_page_telco_comparison_drawer_data_label',
    defaultMessage: 'Data',
  },

  hotspotLabel: {
    id: 'product_page_telco_comparison_drawer_hotspot_label',
    defaultMessage: 'Hotspot',
  },

  priceLabel: {
    id: 'product_page_telco_comparison_drawer_price_label',
    defaultMessage: 'Price',
  },
}
